import { PopoverCommonProps } from '@wix/design-system';
import { useFilterRenderingContext } from '../components/FilterRenderingContext';

export function useWindowFlipPopoverProps(popoverProps?: PopoverCommonProps) {
  const { location } = useFilterRenderingContext();

  return {
    appendTo: 'window' as const,
    flip: true,
    ...(location === 'modal' && { zIndex: 5001 }),
    ...popoverProps,
  };
}
